import React, { useContext } from "react";
import classnames from "classnames";
import ContactPhone from "../contact-phone/ContactPhone";
import ContactLiveChat from "../contact-live-chat/ContactLliveChat";
import ContactLiveChatUnavailable from "../contact-live-chat-unavailable/ContactLiveChatUnavailable";
import { ContactDetailsContext } from "@/context/contact-details-context";

import ContactEmail from "../contact-email/ContactEmail";
import styles from "../contact-methods.module.scss";

const getComponent = (
  newDesign,
  contact,
  solutionId,
  isChatSupported,
  location,
  contactDetails,
  size,
  showGreyBackground,
  liveChatProminenceExperiment,
) => {
  if (contact.name === "phone") {
    return (
      <ContactPhone
        key={contact.name}
        className={classnames(
          styles.cm__container,
          newDesign ? styles["cm__container--new"] : null,
          size === 1 ? styles.cmContainerOneItem : null,
        )}
        config={contactDetails.phone}
        solutionId={solutionId}
      />
    );
  }

  if (contact.name === "chat" && isChatSupported) {
    return (
      <ContactLiveChat
        key={contact.name}
        className={classnames(
          styles.cm__container,
          newDesign ? styles["cm__container--new"] : null,
          size === 1 ? styles.cmContainerOneItem : null,
          showGreyBackground ? styles.chat_container : null,
        )}
        config={contactDetails.chat}
        location={location}
      />
    );
  }

  if (contact.name === "chat-unavailable" && isChatSupported) {
    if (liveChatProminenceExperiment) {
      return (
        <ContactLiveChatUnavailable
          key={contact.name}
          className={classnames(
            styles.cm__container,
            newDesign ? styles["cm__container--new"] : null,
            size === 1 ? styles.cmContainerOneItem : null,
          )}
          config={contactDetails.chat}
        />
      );
    }
    return (
      <div
        key={contact.name}
        data-test="container-chat-unavailable"
        className={classnames(
          styles.cm__container,
          newDesign ? styles["cm__container--new"] : null,
          size === 1 ? styles.cmContainerOneItem : null,
        )}
        style={{ display: "grid", placeContent: "center" }}
      >
        <h4
          style={{
            fontSize: "16px",
            lineHeight: "22px",
            fontWeight: "700",
            marginBottom: 0,
          }}
        >
          Live chat unavailable
        </h4>
      </div>
    );
  }

  if (contact.name === "email" || (contact.name === "chat" && !isChatSupported)) {
    return (
      <ContactEmail
        key={contact.name}
        className={classnames(
          styles.cm__container,
          newDesign ? styles["cm__container--new"] : null,
          size === 1 ? styles.cmContainerOneItem : null,
        )}
        config={contactDetails.email}
        location={location}
      />
    );
  }

  return null;
};

const ContactMethodsList = ({
  fields,
  newDesign,
  solutionId,
  location,
  contactDetails,
  isChatSupported = true,
  showGreyBackground,
}) => {
  const size = fields.length;
  const { liveChatProminenceExperiment } = useContext(ContactDetailsContext);
  return (
    <>
      {fields.map(contact =>
        getComponent(
          newDesign,
          contact,
          solutionId,
          isChatSupported,
          location,
          contactDetails,
          size,
          showGreyBackground,
          liveChatProminenceExperiment,
        ),
      )}
    </>
  );
};

export default ContactMethodsList;
